import { AssetItemProps } from '@design-system/asset-item';

import { ctaBlockMapper } from '~/mappers/ctaBlock';
import { headingBlockMapper } from '~/mappers/headingBlock';
import { imageMapper } from '~/mappers/image';
import { ImageConfig } from '~/mappers/image/models';

import { AssetItem } from './models';

const ULTIMELE_NOUTATI_CAROUSEL_ID = 'ultimele-noutati';

const addIconPrefixToCtaBlocks = (ctaBlocks: AssetItem['ctaBlocks']) =>
  ctaBlocks.map((block) => {
    if (
      block.link &&
      (!block.link.iconPrefix || block.link.iconPrefix.length === 0)
    ) {
      return {
        ...block,
        link: {
          ...block.link,
          iconPrefix: [{ icon: 'arrowRight' }],
        },
      };
    }

    return block;
  });

export const assetItemMapper = (
  { heading, align, tag, ctaBlocks, image, variant, categories }: AssetItem,
  imageConfig: ImageConfig,
  horizontalView: boolean | null,
  componentId?: string
): AssetItemProps => {
  const enhancedCtaBlocks =
    componentId === ULTIMELE_NOUTATI_CAROUSEL_ID
      ? addIconPrefixToCtaBlocks(ctaBlocks)
      : ctaBlocks;

  return {
    headingBlock: headingBlockMapper(heading),
    mediaVariant: variant,
    isHorizontal: horizontalView ?? false,
    categories,
    // TODO: consider handle image as GatsbyImage
    image: imageMapper({ ...image, ...imageConfig }),
    ...(align && { align }),
    ...(tag && { tag }),
    ...(enhancedCtaBlocks.length && {
      ctaBlock: ctaBlockMapper(enhancedCtaBlocks),
    }),
  } as AssetItemProps;
};
